import {
  Checkbox,
  DialogContent,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import type {GetCustomerPopupsResponse} from '@resurs-internal/rb-app-api';
import React, {useState} from 'react';

type Content = NonNullable<
  GetCustomerPopupsResponse['popups'][number]['content']['requiredSingleCheckbox']
>;

interface Props {
  content: Content;
  onConfirm: () => void;
  onClose: () => void;
  isPending: boolean;
}

export const PopupRequiredSingleCheckboxDialog: React.FC<Props> = ({
  content,
  onConfirm,
  onClose,
  isPending,
}) => {
  const [checked, setChecked] = useState(false);

  return (
    <BaseDialog
      open
      image={content.image}
      onClose={onClose}
      actions={[
        {
          title: content.buttonText,
          color: 'primary',
          onClick: onConfirm,
          disabled: !checked || isPending,
        },
      ]}>
      <DialogContent>
        <Stack alignItems="center" gap={2}>
          <Typography typography="h2">{content.title}</Typography>
          <Typography typography="body1">{content.body}</Typography>
          <FormControlLabel
            label={content.checkboxText}
            control={
              <Checkbox
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
            }
          />
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
